import type { RootSearch } from '@/routes/__root'

/**
 * Which integrant set the list shows: the ones DESCRIBED for the job, or the ones already on it. It is a
 * property of the SELECTED profile, and both halves need it — the layout's `context` off `deriveProfiles`,
 * the panel off `useRootSearch` (already derived). One function, so the two keys cannot disagree.
 */
export function jobIntegrantsSource(first: RootSearch['first']): 'described' | 'integrants' {
  return first?.type === 'job' && 'source' in first && first.source === 'integrants' ? 'integrants' : 'described'
}
